import script from "./SearchBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBox.vue?vue&type=script&setup=true&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=050dfc00&lang=css"

const __exports__ = script;

export default __exports__